// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__F5rqq","fileBtn":"File_fileBtn__36q66","closeBtn":"File_closeBtn__1KnRQ","fileSelected":"File_fileSelected__1UyuU","disabled":"File_disabled__3B9Gk"};